import { Brand } from "@org-avp/avp-avengers-project-service-api";
import { createSlice } from "@reduxjs/toolkit";

export const projectOverviewOptionsSliceName = "projectOverviewOptions";

export interface ProjectOverviewOptionsState {
  filter: ProjectOverviewFilterOptions;
  selectedProjectId: string | undefined;
  expandedSectionKeys: ProjectSectionCollapseKey[];
  expandedSubprojectKeys: string[];
}

export interface ProjectOverviewFilterOptions {
  searchText: string;
  searchStatus: StatusFilterType;
  selectedBrands: Brand[];
}

export enum StatusFilterType {
  ACTIVE = "active",
  INACTIVE = "inactive",
  ALL = "all",
}

export enum ProjectSectionCollapseKey {
  PROJECT,
  SUBPROJECTS,
}

const initialState: ProjectOverviewOptionsState = {
  filter: {
    searchText: "",
    searchStatus: StatusFilterType.ACTIVE,
    selectedBrands: [],
  },
  selectedProjectId: undefined,
  expandedSectionKeys: [ProjectSectionCollapseKey.SUBPROJECTS],
  expandedSubprojectKeys: [],
};

const projectOverviewOptionsSlice = createSlice({
  name: projectOverviewOptionsSliceName,
  initialState,
  reducers: {
    setProjectOverviewFilterSearchText(state: ProjectOverviewOptionsState, { payload }: { payload: string }) {
      state.filter.searchText = payload;
    },
    setProjectOverviewFilterSearchStatus(state: ProjectOverviewOptionsState, { payload }: { payload: StatusFilterType }) {
      state.filter.searchStatus = payload;
    },
    setProjectOverviewFilterSelectedBrands(state: ProjectOverviewOptionsState, { payload }: { payload: Brand[] }) {
      state.filter.selectedBrands = payload;
    },
    setProjectOverviewSelectedProjectId(state: ProjectOverviewOptionsState, { payload }: { payload: string | undefined }) {
      state.selectedProjectId = payload;
    },
    setProjectOverviewExpandedSectionKeys(state: ProjectOverviewOptionsState, { payload }: { payload: ProjectSectionCollapseKey[] }) {
      state.expandedSectionKeys = payload;
    },
    setProjectOverviewExpandedSubprojectKeys(state: ProjectOverviewOptionsState, { payload }: { payload: string[] }) {
      state.expandedSubprojectKeys = payload;
    },
  },
});

export interface ProjectOverviewOptionsRootState {
  [projectOverviewOptionsSliceName]: ProjectOverviewOptionsState;
}

export const selectProjectOverviewOptions =
  (state: ProjectOverviewOptionsRootState) => state[projectOverviewOptionsSliceName];
export const selectProjectOverviewFilterOptions =
  (state: ProjectOverviewOptionsRootState) => state[projectOverviewOptionsSliceName].filter;
export const selectProjectOverviewSelectedProjectId =
  (state: ProjectOverviewOptionsRootState) => state[projectOverviewOptionsSliceName].selectedProjectId;
export const selectProjectOverviewExpandedSectionKeys =
  (state: ProjectOverviewOptionsRootState) => state[projectOverviewOptionsSliceName].expandedSectionKeys;
export const selectProjectOverviewExpandedSubprojectKeys =
  (state: ProjectOverviewOptionsRootState) => state[projectOverviewOptionsSliceName].expandedSubprojectKeys;

export const {
  setProjectOverviewFilterSearchText,
  setProjectOverviewFilterSearchStatus,
  setProjectOverviewFilterSelectedBrands,
  setProjectOverviewSelectedProjectId,
  setProjectOverviewExpandedSectionKeys,
  setProjectOverviewExpandedSubprojectKeys,
} = projectOverviewOptionsSlice.actions;

export const projectOverviewOptionsReducer = projectOverviewOptionsSlice.reducer;
